import React, { useState, useEffect, useCallback, useContext } from "react";
import _ from "lodash";
import moment from 'moment';
import clsx from 'clsx';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import {
  useMediaQuery,
  Grid,
  Typography,
  Paper,
  Button,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import { formatMissingCert } from "./Credentials/components";
import { SafetyUserContext } from "src/App";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

//components
import {
  Section,
  CategoryBase,
  ExternalApplicationLink,
  ModuleLink,
  EmptyStateHolder,
} from "@components/organisms";
import { CountiesFilter } from "@components/molecules";

import { faUser } from "@fortawesome/free-regular-svg-icons";
import {
  faInfo,
  faTabletAlt,
  faComments,
  faCheckCircle,
  faQuestionCircle,
  faClock,
  faTimesCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import applications_list from "@assets/data/external_applications_list.json";
import { connect_modules } from "@assets/data/connect_modules_list.js";

// import { Hero } from "./components";
// import { Providers, Download } from "./../LandingPage/components";
// import { AppConfigService } from "services";
import { DashboardService } from "@services";

// redux functions
import { saveEmployeeActionItems } from "@store/dashboard";

// redux functions
import { saveEmployeeProfile } from "@store/credentials";
//API Requests
import { CredentialsService } from "@services";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .hero-shaped": {
      borderBottom: 0,
    },
    "& .hero-shaped__wrapper": {
      [theme.breakpoints.up("md")]: {
        minHeight: `calc(100vh - ${theme.mixins.toolbar["@media (min-width:600px)"].minHeight}px)`,
      },
    },
  },
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(5),
    },
  },
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
  promoSection: {
    background: theme.palette.alternate.main,
    padding: theme.spacing(2, 2),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(4, 2),
    },
  },
  blueStripesGradient: {
    color: "white",
    background:
      //"linear-gradient(90deg, rgba(79,154,201,1) 47%, rgba(11,82,125,1) 100%)",
      "#004987",
  },
  corporateLogoBox: {
    margin: "28px 8px",
    [theme.breakpoints.up("sm")]: {
      width: "calc(calc(100% / 3) - 16px)",
    },
    width: "calc(calc(100% / 2) - 16px)",
  },
  list: {
    width: "100%",
  },
  listItemText: {
    "& > span": {
      fontWeight: "bold",
    },
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  certIcon: {
    minWidth: 30,
  },
  MISSING: {
    color: theme.palette.icon.missing,
  },
  EXPIRED: {
    color: theme.palette.icon.expired,
  },
  EXPIRING: {
    color: theme.palette.icon.expiring,
  },
  credentailsWrapper: {
    "& .MuiCardContent-root": {
      display: "flex",
    },
  },
  headerText: {
    fontWeight: "bold",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
  },
  whiteSpace: {
    whiteSpace: "pre-line",
  },
}));

const CERT_ICONS = {
  MISSING: faQuestionCircle,
  EXPIRED: faTimesCircle,
  EXPIRING: faExclamationCircle,
};

const Dashboard = () => {
  const [displayCounties, setDisplayCounties] = React.useState(false);
  const [displayModule, setDisplayModule] = React.useState({
    credentials: true,
    connect: true,
    corporate_communications: false,
    corporate_applications: true,
  });
  const [isHoveringWorkLocation, setIsHoveringWorkLocation] = React.useState(false);
  const [isHoveringViewCredentials, setIsHoveringViewCredentials] = React.useState(false);
  const { user } = useSelector((state) => state.user);
  const { employeeActionItems } = useSelector((state) => state.dashboard);
  const { currentCounty } = useSelector((state) => state.counties);

  const { isSafetyUser, setIsSafetyUser } = useContext(SafetyUserContext);

  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  const [loading, setLoading] = useState(true);

  const history = useHistory();

  const updateEmployeeLastLogin = useCallback(() => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      DashboardService.updateEmployeeLastLogin({ employeeID: user.employeeNumber }).then((response) => {
        resolve(response);
      }).catch((error) => {
        console.log(error);
        reject();
      }).finally(() => {
        setLoading(false);
      });
    });
  }, []);

  const getActionItems = useCallback(async () => {
    setLoading(true);
    try {
      const response = await DashboardService.employeeActionItems(
        user.employeeNumber
      );
      dispatch(saveEmployeeActionItems(response));
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, []);

  const getEmployeeDetails = useCallback(() => {
    //onPageLoad - fetch employee info - SAMPLE API Call
    setLoading(true);
    // let employeeNum = "100023"; //Brian	L.	Martin's employee number
    //sample api GET request
    CredentialsService.getemployeeProfile(user?.employeeNumber)
      .then((data) => {
        setLoading(false);
        dispatch(saveEmployeeProfile(data[0]));
      })
      .catch((err) => {
        alert(JSON.stringify(err));
        setLoading(false);
      });
  }, []);

  const checkIfSafetyUser = useCallback(() => {
    switch (user.employeeNumber) {
      case "C8102122":
        setIsSafetyUser(true);
        break;
      case "1986211":
        setIsSafetyUser(true);
        break;
      case "C8009650":
        setIsSafetyUser(true);
        break;
      case "20263152":
        setIsSafetyUser(true);
        break;
      case "25008620":
        setIsSafetyUser(true);
        break;
      case "25010202":
        setIsSafetyUser(true);
        break;
      case "26015371":
        setIsSafetyUser(true);
        break;
      case "20111133":
        setIsSafetyUser(true);
        break;
      case "25008673":
        setIsSafetyUser(true);
        break;
      case "20448817":
        setIsSafetyUser(true);
        break;
      case "25008789":
        setIsSafetyUser(true);
        break;
      case "26002860":
        setIsSafetyUser(true);
        break;
      case "26011884":
        setIsSafetyUser(true);
        break;
      case "20143650":
        setIsSafetyUser(true);
        break;
      case "25008103":
        setIsSafetyUser(true);
        break;
      case "25017229":
        setIsSafetyUser(true);
        break;
      case "20027544":
        setIsSafetyUser(true);
        break;
      case "74229":
        setIsSafetyUser(true);
        break;
      case "26011004":
        setIsSafetyUser(true);
        break;
      case "20236756":
        setIsSafetyUser(true);
        break;
      case "25009224":
        setIsSafetyUser(true);
        break;
      case "25013279":
        setIsSafetyUser(true);
        break;
      case "20317208":
        setIsSafetyUser(true);
        break;
      case "25017529":
        setIsSafetyUser(true);
        break;
      case "20563296":
        setIsSafetyUser(true);
        break;
      case "25002050":
        setIsSafetyUser(true);
        break;
      case "20285407":
        setIsSafetyUser(true);
        break;
      case "25008477":
        setIsSafetyUser(true);
        break;
      case "25002060":
        setIsSafetyUser(true);
        break;
      case "25008348":
        setIsSafetyUser(true);
        break;
      case "25010939":
        setIsSafetyUser(true);
        break;
      case "20103846":
        setIsSafetyUser(true);
        break;
      case "948037":
        setIsSafetyUser(true);
        break;
      case "2173562":
        setIsSafetyUser(true);
        break;
      default:
        setIsSafetyUser(false);
        break;
    }
  }, []);

  useEffect(() => {
    updateEmployeeLastLogin().then(() => getEmployeeDetails());
    getActionItems();
    checkIfSafetyUser();
  }, []);

  const routeChange = (path) => {
    history.push(path);
  };

  const renderActionItems = () => {
    if (loading)
      return (
        <div className={classes.center}>
          <CircularProgress color="primary" />
        </div>
      );
    let newEmployeeActionItems = [];
    if (Array.isArray(employeeActionItems)) {
      employeeActionItems.map((v) => {
        let formatLabel = '';
        if (v.disposition === 'MISSING' && v.certNameList.length > 30 && v.certNameList.includes('State')) {
          formatLabel = formatMissingCert(v, 'certNameList', 'or');
          newEmployeeActionItems.push({
            employeeID: v.employeeID,
            expiringDaysOut: v.expiringDaysOut,
            disposition: v.disposition,
            itemCount: v.itemCount,
            certNameList: formatLabel,
            countyName: v.countyName,
            expirationDate: v.expirationDate,
            stateCode: v.stateCode,
          })
        } else {
          newEmployeeActionItems.push(v);
        }
      })
    }
    return (
      <List component="nav" className={classes.list}>
        {newEmployeeActionItems.length > 0 &&
          newEmployeeActionItems.map((v) => {
            return (
              <ListItem button onClick={() => routeChange({ pathname: "/credentials", state: { ...v } })}>
                {CERT_ICONS[v.disposition] && (
                  <ListItemIcon className={classes.certIcon}>
                    <FontAwesomeIcon
                      icon={CERT_ICONS[v.disposition]}
                      size="lg"
                      className={classes[v.disposition]}
                    />
                  </ListItemIcon>
                )}
                <ListItemText
                  className={clsx(classes.listItemText, classes.whiteSpace)}
                  primary={`${v.certNameList} ${_.toLower(
                    v.disposition
                  )} certificate ${v.expiringDaysOut > 0 || ['EXPIRING'].includes(v.disposition) && v.expiringDaysOut === 0 ? `on ${moment(v.expirationDate).format('MM/DD/YYYY')}` : ""
                    }`}
                />
              </ListItem>
            )
          })}
      </List>
    );
  };

  return (
    <div>
      {/* <Section
        className={[classes.promoSection, classes.blueStripesGradient]}
        fullWidth={true}
        disablePadding={true}
      >
        <Section disablePadding={true}>
          <Typography variant="h5" className={classes.headerText}>
            Hello, {user.firstName} {user.lastName} ({user.employeeNumber})
          </Typography> */}
      {/*  <Typography variant="h5" className={classes.headerText}>
            {user.firstName} {user.lastName} ({user.employeeNumber}) -{" "}
            {user.county}, {user.state}
          </Typography> */}
      {/* </Section> */}
      {/* </Section> */}
      <Divider />

      {displayCounties && (
        <CountiesFilter
          openModal={displayCounties}
          setOpenModal={setDisplayCounties}
        />
      )}

      <div className={classes.pagePaddingTop}>
        <div>
          <Section className={classes.sectionNoPaddingTop}>
            <Grid container spacing={isMd ? 4 : 2}>
              {displayModule.credentials && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  data-aos="fade-up"
                  key={1}
                  className={classes.credentailsWrapper}
                >
                  <CategoryBase
                    variant="outlined"
                    withShadow={true}
                    icon={faInfo}
                    title={"My Information"}
                    liftUp
                    subtitle={""}
                    categoryComponent={
                      <Box
                        display="flex"
                        flexWrap="wrap"
                        m={1}
                        bgcolor="background.paper"
                        maxHeight="16rem"
                        style={{ overflowY: "auto" }}
                      >
                        {Array.isArray(employeeActionItems) &&
                          employeeActionItems.length === 0 && (
                            <EmptyStateHolder
                              placeholderText={"You are all caught up for now"}
                            />
                          )}
                        {Array.isArray(employeeActionItems) &&
                          employeeActionItems.length > 0 &&
                          renderActionItems()}
                      </Box>
                    }
                    cta={
                      <Button
                        color="primary"
                        fullWidth
                        size={isHoveringViewCredentials ? "large" : "medium"}
                        onMouseEnter={() => setIsHoveringViewCredentials(true)}
                        onMouseLeave={() => setIsHoveringViewCredentials(false)}
                        onClick={() => routeChange("credentials")}
                      >
                        View Credentials
                      </Button>
                    }
                  />
                </Grid>
              )}

              {displayModule.connect && (
                <Grid item xs={12} md={6} data-aos="fade-up" key={1}>
                  <CategoryBase
                    variant="outlined"
                    withShadow={true}
                    icon={faUser}
                    title={"GMR Connect"}
                    liftUp
                    subtitle={""}
                    categoryComponent={
                      <>
                        <Box
                          display="flex"
                          flexWrap="wrap"
                          m={1}
                          bgcolor="background.paper"
                          justifyContent="start"
                          height="100%"
                        >
                          {(currentCounty === null ||
                            currentCounty.county === undefined) && (
                              <EmptyStateHolder
                                placeholderText={"Select a county to get started"}
                                locationIcon={true}
                              />
                            )}
                          {currentCounty !== null &&
                            currentCounty.county !== undefined &&
                            currentCounty.county.length > 0 &&
                            connect_modules.map((application, index) => (
                              (application.isActive || isSafetyUser) &&
                              <Box key={index} m={2} width="5rem">
                                <ModuleLink
                                  key={index}
                                  name={application.name}
                                  icon={application.icon}
                                  logo={application.logo}
                                  isModuleActive={application.isActive}
                                  externalLink={application.link}
                                  currentCounty={currentCounty}
                                />
                              </Box>
                            ))}
                        </Box>
                      </>
                    }
                    cta={
                      <Tooltip title="Click to change location.">
                        <Button
                          color="primary"
                          fullWidth
                          size={isHoveringWorkLocation ? "large" : "medium"}
                          onMouseEnter={() => setIsHoveringWorkLocation(true)}
                          onMouseLeave={() => setIsHoveringWorkLocation(false)}
                          onClick={() => setDisplayCounties(true)}
                        >
                          {/* <Typography variant="body2" color="primary"> */}
                          {`Work Location:  ${currentCounty?.county}${currentCounty.state ? `, ${currentCounty?.state}` : ''}` || "Select County"}
                          {/* </Typography> */}
                        </Button>
                      </Tooltip>
                    }
                  />
                </Grid>
              )}

              {displayModule.corporate_communications && (
                <Grid item xs={12} md={6} data-aos="fade-up" key={1}>
                  <CategoryBase
                    variant="outlined"
                    withShadow={true}
                    icon={faComments}
                    title={"Corporate Communications"}
                    liftUp
                    subtitle={""}
                    categoryComponent={
                      <Box
                        display="flex"
                        flexWrap="wrap"
                        m={1}
                        bgcolor="background.paper"
                      >
                        <EmptyStateHolder
                          placeholderText={"You are all caught up for now"}
                        />
                      </Box>
                    }
                    cta={
                      <Button
                        color="primary"
                        fullWidth
                        size="large"
                        onClick={() => routeChange("communications")}
                      >
                        View All
                      </Button>
                    }
                  />
                </Grid>
              )}

              {displayModule.corporate_applications && (
                <Grid item xs={12} md={6} data-aos="fade-up" key={1}>
                  <CategoryBase
                    variant="outlined"
                    withShadow={true}
                    icon={faTabletAlt}
                    title={"GMR Applications"}
                    liftUp
                    subtitle={""}
                    categoryComponent={
                      <Box
                        display="flex"
                        flexWrap="wrap"
                        m={1}
                        bgcolor="background.paper"
                      >
                        {applications_list.map((application, index) => (
                          <Box key={index} className={classes.corporateLogoBox}>
                            <ExternalApplicationLink
                              key={index}
                              name={application.name}
                              logo={application.logo}
                              externalLink={application.externalLink}
                            />
                          </Box>
                        ))}
                      </Box>
                    }
                  />
                </Grid>
              )}
            </Grid>
          </Section>
        </div>
      </div>

      <Divider />
    </div>
  );
};

export default Dashboard;
